import { Grid } from "@mui/material";
import { ReactNode } from "react";
import { GuardianUploadBanner } from "../../components";
import { ProfileLayout, ProfileLinks, ProfileSurface, ProfileSurfaceVariant } from "./ProfileComponents";

type ProfileProps = {
  children?: ReactNode;
  /** Colour of the panel the tab row is joined to. Leave it out for the legacy layout
      (row floating above whatever the page renders) — the secondary /dashboard routes
      still rely on that. */
  surface?: ProfileSurfaceVariant;
  /** Land image behind the row and hero when `surface="image"`. */
  image?: string;
  /** What sits inside the surface; defaults to `children`. When given, `children`
      render below the surface on the page ground — the Wallet puts its hero inside
      and its stats and table underneath. */
  panel?: ReactNode;
};

const Profile = ({ children, surface, image, panel }: ProfileProps) => {
  return (
    <Grid container sx={{ flexWrap: "wrap", flexDirection: "column", height: "100%", border: "none" }}>
      <GuardianUploadBanner />
      {!surface && <ProfileLinks />}

      <ProfileLayout>
        {surface && (
          <ProfileSurface variant={surface} image={image} data-profile-surface="">
            <ProfileLinks joined />
            {panel !== undefined ? panel : children}
          </ProfileSurface>
        )}
        {(!surface || panel !== undefined) && children}
      </ProfileLayout>
    </Grid>
  );
};

export default Profile;
